/**
 * @generated SignedSource<<247bdc5458ce6604d9dd5922b56248b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ForgotPassword_Query$variables = Record<PropertyKey, never>;
export type ForgotPassword_Query$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"AuthGate_User" | "ForgotPassword_isAllowed" | "auth_checkAuthForPage">;
  } | null | undefined;
};
export type ForgotPassword_Query = {
  response: ForgotPassword_Query$data;
  variables: ForgotPassword_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unconfirmedEmail",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confirmedEmail",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passwordSetupRequired",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "statuses": [
        "active",
        "paused"
      ]
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableTimesheets",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowExpensesAccess",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentsEnabled",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v12 = {
  "alias": "offers",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "statuses": [
          "offer_made"
        ]
      }
    },
    (v10/*: any*/)
  ],
  "concreteType": "ContractConnection",
  "kind": "LinkedField",
  "name": "freelancerContracts",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": "freelancerContracts(filters:{\"statuses\":[\"offer_made\"]},first:0)"
},
v13 = {
  "alias": "interviews",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "stage": "interview"
      }
    },
    (v10/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"stage\":\"interview\"},first:0)"
},
v14 = {
  "alias": "screening",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "withJobScreening": true
      }
    },
    (v10/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"withJobScreening\":true},first:0)"
},
v15 = {
  "alias": "applications",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "statuses": [
          "job_application_sent",
          "job_application_draft"
        ]
      }
    },
    (v10/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"statuses\":[\"job_application_sent\",\"job_application_draft\"]},first:0)"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMember",
  "storageKey": null
},
v17 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isMember",
  "selections": [
    (v0/*: any*/),
    (v16/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isClient",
  "storageKey": null
},
v19 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isClient",
  "selections": [
    (v0/*: any*/),
    (v18/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guest",
  "storageKey": null
},
v21 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isGuest",
  "selections": [
    (v20/*: any*/),
    (v0/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ForgotPassword_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AuthGate_User"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "auth_checkAuthForPage",
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "auth_getRedirectPath",
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "auth_getDefaultPath",
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v0/*: any*/),
                      {
                        "alias": "activeContracts",
                        "args": (v5/*: any*/),
                        "concreteType": "ContractConnection",
                        "kind": "LinkedField",
                        "name": "freelancerContracts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contract",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Firm",
                                "kind": "LinkedField",
                                "name": "firm",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
                      },
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v17/*: any*/),
                      (v19/*: any*/),
                      (v21/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  (v21/*: any*/),
                  (v17/*: any*/),
                  (v19/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "ForgotPassword_isAllowed",
            "selections": [
              (v21/*: any*/)
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ForgotPassword_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": "activeContracts",
            "args": (v5/*: any*/),
            "concreteType": "ContractConnection",
            "kind": "LinkedField",
            "name": "freelancerContracts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Contract",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Firm",
                    "kind": "LinkedField",
                    "name": "firm",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v18/*: any*/),
          (v20/*: any*/),
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "af2e83f90f21dd3f7199b3064a0fe180",
    "id": null,
    "metadata": {},
    "name": "ForgotPassword_Query",
    "operationKind": "query",
    "text": "query ForgotPassword_Query {\n  currentUser {\n    ...AuthGate_User\n    ...auth_checkAuthForPage\n    ...ForgotPassword_isAllowed\n    id\n  }\n}\n\nfragment AuthGate_User on User {\n  ...auth_useAuthGate\n}\n\nfragment ForgotPassword_isAllowed on User {\n  ...user_isGuest\n}\n\nfragment auth_checkAuthForPage on User {\n  ...auth_getRedirectPath\n}\n\nfragment auth_getDefaultPath on User {\n  confirmedEmail\n  passwordSetupRequired\n  status\n  activeContracts: freelancerContracts(first: 1, filters: {statuses: [active, paused]}) {\n    nodes {\n      enableTimesheets\n      allowExpensesAccess\n      paymentsEnabled\n      firm {\n        slug\n        id\n      }\n      id\n    }\n  }\n  offers: freelancerContracts(first: 0, filters: {statuses: [offer_made]}) {\n    totalCount\n  }\n  interviews: freelancerJobApplications(first: 0, filters: {stage: interview}) {\n    totalCount\n  }\n  screening: freelancerJobApplications(first: 0, filters: {withJobScreening: true}) {\n    totalCount\n  }\n  applications: freelancerJobApplications(first: 0, filters: {statuses: [job_application_sent, job_application_draft]}) {\n    totalCount\n  }\n  ...user_isMember\n  ...user_isClient\n  ...user_isGuest\n}\n\nfragment auth_getRedirectPath on User {\n  status\n  unconfirmedEmail\n  confirmedEmail\n  integrationName\n  ...auth_getDefaultPath\n  ...user_isGuest\n  ...user_isMember\n  ...user_isClient\n}\n\nfragment auth_useAuthGate on User {\n  ...auth_useRedirectPath\n}\n\nfragment auth_useRedirectPath on User {\n  ...auth_getRedirectPath\n}\n\nfragment user_isClient on User {\n  status\n  isClient\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_isMember on User {\n  status\n  isMember\n}\n"
  }
};
})();

(node as any).hash = "7640e611710f9a10dde44423c134764d";

export default node;
